import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { FAQS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/faqs/new")({
  component: () => <DeptContentForm cfg={FAQS} />,
});
